import client from "../client";

export const reportsApi = {
    /**
     * Upcoming-only fetch. Default scope on the BE. Used by the
     * Reports page so the curated view never lists late doses.
     */
    async upcomingVaccinations() {
        const { data } = await client.get("/reports/upcoming-vaccinations");
        return data;
    },
    /**
     * Reminders-scope fetch — Upcoming + Due only. Overdue is
     * deliberately excluded per the Reminders page spec ("DUE and
     * UPCOMING vaccinations only").
     */
    async vaccinationReminders() {
        const { data } = await client.get(
            "/reports/upcoming-vaccinations?scope=reminders",
        );
        return data;
    },
    async growthReminders() {
        const { data } = await client.get("/reports/growth-reminders");
        return data;
    },
};
